import { createContext, useContext, useState, useCallback } from "react";
import BookingDialog from "@/components/BookingDialog";

const BookingContext = createContext(null);

export function BookingProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [preset, setPreset] = useState({ propertyId: "", services: [], providers: [], arrival: "", departure: "" });

  const openBooking = useCallback((p = {}) => {
    setPreset({
      propertyId: p.propertyId || "",
      services: p.services || [],
      providers: p.providers || [],
      arrival: p.arrival || "",
      departure: p.departure || "",
      guests: p.guests || "",
    });
    setOpen(true);
  }, []);

  return (
    <BookingContext.Provider value={{ openBooking }}>
      {children}
      <BookingDialog open={open} onClose={() => setOpen(false)} preset={preset} />
    </BookingContext.Provider>
  );
}

export const useBooking = () => useContext(BookingContext);
